import * as tslib_1 from "tslib";
import { Select, Store } from '@ngxs/store';
import { TitleState } from '../../../titles/state/title-state';
import { Observable } from 'rxjs';
import { getFaviconFromUrl } from '@common/core/utils/get-favicon-from-url';
import { PlayVideo } from '../../../player/state/player-state-actions';
var TitleVideoCarouselComponent = /** @class */ (function () {
    function TitleVideoCarouselComponent(store) {
        this.store = store;
        this.mediaItem = this.store.selectSnapshot(TitleState.titleOrEpisode);
    }
    TitleVideoCarouselComponent.prototype.getThumbnail = function (video) {
        return video.thumbnail || this.mediaItem['backdrop'] || this.mediaItem.poster;
    };
    TitleVideoCarouselComponent.prototype.playVideo = function (video) {
        if (video.type === 'external') {
            window.open(video.url, '_blank');
        }
        else {
            this.store.dispatch(new PlayVideo(video, this.mediaItem));
        }
    };
    TitleVideoCarouselComponent.prototype.getFavicon = function (url) {
        return getFaviconFromUrl(url);
    };
    tslib_1.__decorate([
        Select(TitleState.loading),
        tslib_1.__metadata("design:type", Observable)
    ], TitleVideoCarouselComponent.prototype, "loading$", void 0);
    tslib_1.__decorate([
        Select(TitleState.videos),
        tslib_1.__metadata("design:type", Observable)
    ], TitleVideoCarouselComponent.prototype, "videos$", void 0);
    return TitleVideoCarouselComponent;
}());
export { TitleVideoCarouselComponent };
